module.exports = __webpack_public_path__ + "components/location-subheader/static/background--1-28c101c4a83977e562b33367e71210af.jpg";